import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { ofType } from 'redux-observable';
import { mapTo, map, delay, filter } from 'rxjs/operators';
import { replace } from 'react-router-redux';

import { useRedux } from 'util/hook/redux';

export const openAlert = createAction('OPEN_ALERT', (type, data) => ({
	type,
	data,
}));

export const openWarningAlert = data => openAlert('warning', data);
export const openNormalAlert = data => openAlert('normal', data);

export const closeAlert = createAction('CLOSE_ALERT');

export const openAlertEpic = action$ =>
	action$.pipe(
		ofType('OPEN_ALERT'),
		delay(3000),
		mapTo(closeAlert()),
	);

export const openWarningAlertOnError = createAction(
	'OPEN_WARNING_ALERT_ON_ERROR',
	data => (dispatch, getState) => {
		const {
			routing: {
				locationBeforeTransitions: { pathname },
			},
		} = getState();

		if (pathname !== '/') {
			dispatch(replace('/'));
		}

		dispatch(openWarningAlert(data));
	},
);

export const errorHandleEpic = action$ =>
	action$.pipe(
		filter(action => action.type.includes('REJECTED')),
		map(action => {
			// Handle the fetch/authFetch error
			if (action.payload instanceof Error) {
				if (action.payload.message === 'Token not exist') {
					return openWarningAlertOnError('已登出');
				}

				if (action.payload.message === 'Access token expired') {
					return openWarningAlert('已登出');
				}

				console.error(action.payload);

				return openWarningAlert(action.payload.message);
			}

			return action.payload;
		}),
	);

const reducer = {
	alert: handleActions(
		{
			OPEN_ALERT: (state, action) => ({
				...state,

				type: action.payload.type,
				active: true,
				data: action.payload.data,
			}),

			CLOSE_ALERT: state => ({
				...state,

				type: '',
				active: false,
				data: '',
			}),
		},
		{
			type: '',
			active: false,
			data: '',
		},
	),
};

const selectAlert = createSelector(
	state => state.alert,
	alert => alert,
);

export const useAlert = () =>
	useRedux(selectAlert, { openAlert, openNormalAlert, openWarningAlert, closeAlert });

export default { reducer };
